<template>
  <MainLayout v-if="isAuthenticated" />
  <Login v-else />
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '../stores/authStore';
import MainLayout from '../components/MainLayout.vue';
import Login from './Login.vue';

export default {
  name: 'HomeEntry',
  components: {
    MainLayout,
    Login
  },
  setup() {
    const authStore = useAuthStore();
    return {
      isAuthenticated: computed(() => authStore.isAuthenticated)
    };
  }
}
</script>
